import React from 'react';
import { useForm } from 'react-hook-form';
// eslint-disable-next-line import/no-unresolved
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '~/components/ui/Button';
import { Link } from '~/components/ui/Link';
import { ITotalFormValue } from './IExpertPlatformSubmitQuestion';

interface TFormValues {
  name: string;
  email: string;
}

const PersonalInformation: React.FC<{
  setActiveStepId: React.Dispatch<React.SetStateAction<number>>;
  setFormValues: React.Dispatch<React.SetStateAction<ITotalFormValue>>;
  formValues: ITotalFormValue;
}> = ({ setActiveStepId, setFormValues, formValues }) => {
  const { register, handleSubmit, formState } = useForm<TFormValues>({
    mode: 'onTouched',
    defaultValues: {
      name: formValues.name,
      email: formValues.email,
    },
  });

  const { errors } = formState;

  const onSubmit = ({ email, name }: TFormValues): void => {
    setFormValues((prev) => ({ ...prev, email, name }));
    setActiveStepId(2);
  };

  return (
    <form
      className="w-full space-y-[24px]"
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      <div className="w-full space-y-[12px]">
        <label
          htmlFor="name"
          className="font-avantgarde text-[14px] font-bold leading-[18.2px] text-blue-900"
        >
          Wat is je naam <span className="text-tomato-700">*</span>
        </label>
        <p className="font-body text-[16px] font-normal leading-[26.4px] text-stone-800">
          Gebruik je eigen volledige naam of bijvoorbeeld alleen je voornaam of
          voorletters.
        </p>
        <input
          type="text"
          id="name"
          placeholder="Jouw zichtbare naam"
          className="w-full rounded-[4px] border border-stone-200 px-[7px] py-[10px] placeholder-stone-200 outline-none md:w-[40%]"
          {...register('name', {
            required: {
              value: true,
              message: ' Dit veld is verplicht',
            },
            minLength: {
              value: 2,
              message: 'Uw naam moet tussen de 2 en 50 tekens bevatten.',
            },
            maxLength: {
              value: 50,
              message: 'Uw naam moet tussen de 2 en 50 tekens bevatten.',
            },
          })}
        />
        {errors.name && <p className="text-tomato-700">{errors.name.message}</p>}
      </div>
      <div className="w-full space-y-[12px]">
        <label
          htmlFor="email"
          className="font-avantgarde text-[14px] font-bold leading-[18.2px] text-blue-900"
        >
          {' '}
          Wat is je e-mailadres? <span className="text-tomato-700">*</span>
        </label>
        <p className="font-body text-[16px] font-normal leading-[26.4px] text-stone-800">
          We vragen naar je e-mailadres zodat we een bevestiging kunnen sturen
          wanneer de review door ons is geplaatst. We respecteren je privacy.
          Bekijk het{' '}
          <a href={`${origin}/home/privacy`} target="_blank">
            privacybeleid van Advieskeuze.
          </a>
        </p>
        <input
          type="email"
          id="email"
          placeholder="Jouw e-mailadres"
          className="w-full rounded-[4px] border border-stone-200 px-[7px] py-[10px] placeholder-stone-200 outline-none md:w-[40%]"
          {...register('email', {
            required: {
              value: true,
              message: ' Dit veld is verplicht',
            },
            pattern: {
              value: /^[\w._%+-]+@([\w-]+\.)+[\w-]{2,}$/,
              message: ' Dit is geen geldig e-mailadres',
            },
          })}
        />
        {errors.email && <p className="text-tomato-700">{errors.email.message}</p>}
      </div>
      <div className="w-full rounded-[4px] border border-blue-200 bg-blue-50 px-[12px] py-[16px]">
        <p className="font-body text-[16px] font-normal leading-[26.4px] text-stone-800">
          De vraag wordt na indienen voorgelegd aan één of meerdere adviseurs en
          zal anoniem zichtbaar worden op het <br />
          <a href={`${origin}/expert`} className="text-blue-700 hover:text-blue-800 underline">
            expertplatform.
          </a>
        </p>
      </div>
      <div className="flex flex-col gap-[24px] pt-[24px] md:flex-row">
        <Link
          href="/expert"
          variant="default"
          className="border-stone-200 bg-stone-100 font-bold md:text-sm"
        >
          <FontAwesomeIcon icon={faChevronLeft as IconProp} />
          Terug
        </Link>
        <Button
          data-testId="sub_pd"
          variant="primary"
          type="submit"
        >
          Ga verder
          <FontAwesomeIcon icon={faChevronRight as IconProp} />
        </Button>
      </div>
    </form>
  );
};

// eslint-disable-next-line import/no-default-export
export default PersonalInformation;
